export interface BaseLayout {
  documentPageNumber: number
}

export interface PDFLayout extends BaseLayout {
  fileKey: string
  pdfPageNumber: number
}

export namespace PDFLayout {
  export function is(value: any): value is PDFLayout {
    return (
      typeof value === 'object' &&
      value !== null &&
      typeof value.fileKey === 'string' &&
      typeof value.pdfPageNumber === 'number' &&
      value.pdfPageNumber > -1
    )
  }
}

export type PageLayout = BaseLayout | PDFLayout
